import styled from 'styled-components';
import { media, layout, colorUtils } from '@prisjakt/ui-base';

export const ExpandButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color ${layout.animations.buttonTransition};
  background-color: ${p => p.theme.bg.secondary};
  border-radius: 4px;
  width: 30px;
  height: 30px;
  color: ${p => p.theme.text.secondary};

  svg path {
    fill: ${p => p.theme.icons.secondary};
  }

  ${media.smallOnly`
    background-color: transparent;
  `}
`;

export const ExpandWrapper = styled.button`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  min-height: 100%;
  &:hover ${ExpandButton} {
    background-color: ${p => colorUtils.shadeColor(p.theme.bg.secondary, -20)};

    ${media.smallOnly`
      background-color: transparent;
    `}
  }
`;
